import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { Observable, map } from 'rxjs';
import { RequestType } from '../types';



@Injectable({
	providedIn: 'root'
})
export class RequestlimitationCheckService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private utilsServise: UtilsService,
		private httpClient: HttpClient
	) { }

	checkLimitation(requestType: RequestType): Observable<any> {
		return this.httpClient
			.get<any>(`${this.appConfig.apiEndpoint}/v2/Request/Limitation/Info/${requestType}`)
			.pipe(map(this.utilsServise.handleResponse));
	}
}
